import React from "react"
import SideNav from "./SideNav"
import { Drawer, DrawerOverlay, DrawerContent } from '@chakra-ui/react'

interface Props {
  isOpen: boolean,
  onClose: () => void
}

export function SideNavDrawer({ isOpen, onClose }: Props) {
  return (
    <>
      <Drawer 
        placement='left' onClose={onClose} 
        isOpen={isOpen}
      >
        <DrawerOverlay />

        <DrawerContent 
          w='100%' 
          maxW={{ base: '14rem', lg: '15rem' }}>
          <SideNav display='block'/>
        </DrawerContent>
      </Drawer>
    </>
  )
}